module.exports = __webpack_public_path__ + "static/media/border-vertical.dd69bc29.svg";